module.exports = __webpack_public_path__ + "img/you_are_a_badass.657a72e5.jpg";